export default __webpack_public_path__ + "static/media/null.d0965acf.png";